const DEFAULT_API_BASE_CLIENT = (process.env.REACT_APP_API_BASE_CLIENT || "").trim().replace(/\/+$/, "");
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const CHAT_ARCHIVE_DAYS = Number(process.env.REACT_APP_CHAT_ARCHIVE_DAYS || 30);
export const SERVER_SELECTION_ENABLED = process.env.REACT_APP_ALLOW_SERVER_OVERRIDE === "1";

export const STORAGE_KEYS = {
    MOBILE_ACCESS_TOKEN: "WR_MOBILE_ACCESS_TOKEN",
    MOBILE_REFRESH_TOKEN: "WR_MOBILE_REFRESH_TOKEN",
    FCM_TOKEN_ANDROID: "WR_FCM_TOKEN_ANDROID",
    FCM_TOKEN_ANDROID_SENT: "WR_FCM_TOKEN_ANDROID_SENT",
    LAST_PUSH: "WR_LAST_PUSH",
    ACTIVE_CLIENT_CONTEXT_ID: "WR_ACTIVE_CLIENT_CONTEXT_ID",
    API_BASE_OVERRIDE: "WR_CLIENT_API_BASE_OVERRIDE",
    SERVER_SELECTION_SEEN: "WR_CLIENT_SERVER_SELECTION_SEEN",
};

function normalizeApiBase(value) {
    const normalized = (value || "").trim().replace(/\/+$/, "");
    if (!normalized) return "";

    let parsed;
    try {
        parsed = new URL(normalized);
    } catch (_) {
        throw new Error("Вкажіть повну адресу сервера у форматі https://domain.tld");
    }

    if (!["http:", "https:"].includes(parsed.protocol)) {
        throw new Error("Підтримуються лише http:// або https:// адреси сервера");
    }

    return parsed.toString().replace(/\/+$/, "");
}

function getStoredApiBaseOverride() {
    if (typeof window === "undefined") return "";
    try {
        return localStorage.getItem(STORAGE_KEYS.API_BASE_OVERRIDE) || "";
    } catch (_) {
        return "";
    }
}

function resolveApiBaseClient() {
    return normalizeApiBase(getStoredApiBaseOverride()) || DEFAULT_API_BASE_CLIENT;
}

export let API_BASE_CLIENT = resolveApiBaseClient();

export function isCapacitorRuntime() {
    try {
        return typeof window !== "undefined" && !!window.Capacitor;
    } catch (_) {
        return false;
    }
}

export function shouldAllowServerSelection() {
    return SERVER_SELECTION_ENABLED && isCapacitorRuntime();
}

export function getDefaultApiBaseClient() {
    return DEFAULT_API_BASE_CLIENT;
}

export function setApiBaseClient(value) {
    const normalized = normalizeApiBase(value);
    try {
        localStorage.setItem(STORAGE_KEYS.API_BASE_OVERRIDE, normalized);
        localStorage.setItem(STORAGE_KEYS.SERVER_SELECTION_SEEN, "1");
    } catch (_) {
        // ignore
    }
    API_BASE_CLIENT = normalized;
    return API_BASE_CLIENT;
}

export function resetApiBaseClient() {
    try {
        localStorage.removeItem(STORAGE_KEYS.API_BASE_OVERRIDE);
        localStorage.setItem(STORAGE_KEYS.SERVER_SELECTION_SEEN, "1");
    } catch (_) {
        // ignore
    }
    API_BASE_CLIENT = DEFAULT_API_BASE_CLIENT;
    return API_BASE_CLIENT;
}

export function hasSeenServerSelection() {
    try {
        return localStorage.getItem(STORAGE_KEYS.SERVER_SELECTION_SEEN) === "1";
    } catch (_) {
        return false;
    }
}

export function markServerSelectionSeen() {
    try {
        localStorage.setItem(STORAGE_KEYS.SERVER_SELECTION_SEEN, "1");
    } catch (_) {
        // ignore
    }
}
